const updateVariantInput = () => {
  const productForms = document.querySelectorAll(
    `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
  );
  productForms.forEach((productForm) => {
    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
};

const updateVariantStatuses = () => {
  const selectedOptionOneVariants = this.variantData.filter(
    (variant) => this.querySelector(":checked").value === variant.option1
  );
  const inputWrappers = [...this.querySelectorAll(".product-form__input")];
  inputWrappers.forEach((option, index) => {
    if (index === 0) return;
    const optionInputs = [
      ...option.querySelectorAll('input[type="radio"], option'),
    ];
    const previousOptionSelected =
      inputWrappers[index - 1].querySelector(":checked").value;
    const availableOptionInputsValue = selectedOptionOneVariants
      .filter(
        (variant) =>
          variant.available &&
          variant[`option${index}`] === previousOptionSelected
      )
      .map((variantOption) => variantOption[`option${index + 1}`]);
    this.setInputAvailability(optionInputs, availableOptionInputsValue);
  });
};

const setInputAvailability = (listOfOptions, listOfAvailableOptions) => {
  listOfOptions.forEach((input) => {
    if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
      input.innerText = input.getAttribute("value");
    } else {
      input.innerText = Moonbase.variantStrings.unavailable_with_option.replace(
        "[value]",
        input.getAttribute("value")
      );
    }
  });
};

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.sizeSelect = this.querySelector(".product-form__size-select");
        this.sizeSelect.addEventListener("change", this.onSizeSelectChange);
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.variantInventoryJSON = JSON.parse(
          document.querySelector("[data-variant-json]")?.innerHTML
        );
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        if (this.variantInventoryJSON.length == 1) {
          this.form
            .querySelector("#ProductSubmitButton-product-page-form")
            .removeAttribute("disabled");
        }

        document.addEventListener("liquid-ajax-cart:request-end", (event) => {
          const response = event.detail.requestState.responseData;
          this.handleErrorMessageProductPage(response);
        });
      }

      onSizeSelectChange(event) {
        const variantInventoryJSON = JSON.parse(
          document.querySelector("[data-variant-json]").innerHTML
        );
        const sizeType = event.target.value.toLowerCase();
        const variantInputs = this.form.querySelectorAll(
          ".variant-option__label"
        );
        variantInputs.forEach((input) => {
          const matchingVariant = variantInventoryJSON.find(
            (variant) => variant.eu === input.dataset.size
          );
          input.innerText = matchingVariant[sizeType];
        });
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const liquidAjaxCart = window.liquidAjaxCart;
        this.submitButton = this.querySelector('[type="submit"]');
        const spinner = this.submitButton.querySelector(
          ".loading-overlay__spinner"
        );
        if (spinner) spinner.classList.remove("hidden");
        this.submitButton.classList.add("loading");
        setTimeout(() => {
          spinner.classList.add("hidden");
          this.submitButton.classList.remove("loading");
        }, 2000);
      }

      handleErrorMessageProductPage(response) {
        const status = response.status;
        const message = response.body.message;
        const errorContainer = document.querySelector('[data-ajax-cart-errors]');

        if (!errorContainer) return;

        if (status === 400 && message === "Parameter Missing or Invalid") {
          errorContainer.textContent = 'Please select your size.';
        } else {
          errorContainer.textContent = '';
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateFormInputID();
    this.resetErrorMessage();
    if (!this.currentVariant) {
      // this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateLowStockMessage();
      this.updateDeliveryMessage();
      this.updateLineItemProperties();
      this.enableATC();
    }
  }

  resetErrorMessage() {
    const errorContainer = document.querySelector('[data-ajax-cart-errors]');
    if (!errorContainer) return;
    errorContainer.textContent = '';
  }

  enableATC() {
    const productForm = document.querySelector("product-form");
    if (!productForm) return;
    const addToCartButton = productForm.querySelector('[name="add"]');
    if (!addToCartButton) return;
    addToCartButton.removeAttribute("disabled");
  }

  updateLineItemProperties() {
    const productForm = document.querySelector("product-form");
    if (!productForm) return;
    const lineItemProperties = productForm.querySelector(
      "#sizing-line-item-property"
    );
    if (!lineItemProperties) return;
    const variantInventoryJSON = JSON.parse(
      document.querySelector("[data-variant-json]").innerHTML
    );
    const matchingVariant = variantInventoryJSON.find(
      (variant) => variant.id === this.currentVariant.id
    );
    if (
      !matchingVariant ||
      !matchingVariant.uk ||
      !matchingVariant.eu ||
      !matchingVariant.us
    )
      return;
    lineItemProperties.value = `EU: ${matchingVariant.eu} / UK: ${matchingVariant.uk} / US: ${matchingVariant.us}`;
  }

  updateLowStockMessage() {
    const variantInventoryJSON = JSON.parse(
      document.querySelector("[data-variant-json]").innerHTML
    );
    const matchingVariant = variantInventoryJSON.find(
      (variant) => variant.id === this.currentVariant.id
    );
    const lowStockMessage = document.querySelector(
      `.product-form__low-stock-message`
    );
    if (!lowStockMessage) return;
    console.log(matchingVariant.inventory, Moonbase.productLowStockThreshold);
    if (matchingVariant.management == "shopify") {
      lowStockMessage.classList.toggle(
        "hidden",
        matchingVariant.inventory > Moonbase.productLowStockThreshold
      );
    } else {
      lowStockMessage.classList.add("hidden");
    }
  }

  updateDeliveryMessage() {
    const variantInventoryJSON = JSON.parse(
      document.querySelector("[data-variant-json]").innerHTML
    );
    const matchingVariant = variantInventoryJSON.find(
      (variant) => variant.id === this.currentVariant.id
    );
    const deliveryMessage = document.querySelector(
      `.product-form__delivery-message`
    );
    if (!deliveryMessage) return;
    const textSpan = deliveryMessage.querySelector("span");
    if (
      matchingVariant.delivery_message === "" ||
      !matchingVariant.delivery_message
    ) {
      deliveryMessage.classList.add("hidden");
    } else {
      deliveryMessage.classList.remove("hidden");
      this.currentVariant.delivery_message === "";
      textSpan.textContent = matchingVariant.delivery_message;
    }
  }

  updateFormInputID() {
    const productInfo = this.closest("ajax-cart-product-form");
    if (!productInfo) return;
    const input = productInfo.querySelector(".product-variant-id");
    if (!input || this.currentVariant == undefined) return;
    input.value = this.currentVariant.id;
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const gallerySwiper = document.querySelector(
      ".product-main__gallery"
    ).swiper;
    const mediaId = this.currentVariant.featured_media.id.toString();
    gallerySwiper.slides.forEach((slide) => {
      const mediaIdString = slide
        .querySelector("[data-media-id]")
        .dataset.mediaId.toString();
      if (mediaIdString === mediaId) {
        gallerySwiper.slideToLoop(slide.dataset.swiperSlideIndex);
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText =
          window.Moonbase.variantStrings.unavailable_with_option.replace(
            "[value]",
            input.getAttribute("value")
          );
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.Moonbase.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = Moonbase.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = Moonbase.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// Create a web component for the quantity-input
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.minusButton = this.querySelector(".minus");
    this.plusButton = this.querySelector(".plus");
    this.quantityInput = this.querySelector(".quantity__input");
    this.init();
  }

  init() {
    this.minusButton.addEventListener("click", this.minusQty.bind(this));
    this.plusButton.addEventListener("click", this.addQty.bind(this));
  }

  minusQty() {
    if (parseInt(this.quantityInput.value) > 1) {
      this.quantityInput.value = --this.quantityInput.value;
    }
  }

  addQty() {
    if (parseInt(this.quantityInput.value) < parseInt(this.quantityInput.max)) {
      this.quantityInput.value = ++this.quantityInput.value;
    } else {
      this.plusButton.setAttribute("disabled", "disabled");
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class ShareBlock extends VariantSelects {
  constructor() {
    super();
    this.openButton = this.querySelector("[name='share-button']");
    this.closeButton = this.querySelector("[name='close-button']");
    this.shareBlock = this.querySelector(".share-block");

    this.openButton.addEventListener(
      "click",
      this.toggleShareOptions.bind(this)
    );

    this.closeButton.addEventListener(
      "click",
      this.toggleShareOptions.bind(this)
    );
  }

  toggleShareOptions() {
    this.shareBlock.classList.toggle("hidden");
  }
}

customElements.define("share-block", ShareBlock);
